import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { initializeApp } from "firebase/app";
import {
  getAuth,
  getRedirectResult,
  signInWithPopup,
  signInWithRedirect,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  onAuthStateChanged,
  setPersistence, 
  browserSessionPersistence,
} from "firebase/auth";
import Api from "../Api/Api.json";
import axios from 'axios';
import SidebarNav from "./SidebarNav";
import {auth} from '../functions/firebase';
import { set } from "firebase/database";
// Firebase Configuration (Replace with your credentials)

/*
const firebaseConfig = {
  apiKey: "AIzaSyB053LkC_i7zIZn6J2f9sasHdv7kVVexEI",
  authDomain: "upskill-semion.firebaseapp.com",
  projectId: "upskill-semion",
  storageBucket: "upskill-semion.firebasestorage.app",
  messagingSenderId: "315425570609",
  appId: "1:315425570609:web:9cfaea9731a0de495afa10",
  measurementId: "G-ETYHZDZFY1"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
*/
// Providers
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

const SocialLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userInfo, setUserInfo] = useState(null);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [recaptchaVerifier, setRecaptchaVerifier] = useState(null);

  const navigate=useNavigate();
  // Function to send user UID back to the app
  const getBackendIDFromFirebaseUID = async (uid) => {
    console.log("User UID:", uid);
    const headers = { headers: { "Content-Type": "application/json" } }
    const url = Api.UPSKILL_USER_API;
    const requestData = {
      task: 'getUIDFromFirebaseUpskillUID',
      uid:uid,
    };
    console.log(requestData);
    axios.post(url,requestData,headers)
  .then(response=>{
    setUserInfo(response.data);
    console.log(response.data);
    localStorage.setItem('upskill_user_info',JSON.stringify(response.data));
    navigate('/landing');
  })
  .catch(error=>{
    console.log(error)
  });

  };



  // Google Login
  const handleGoogleLogin = async () => {
    console.log("Google Login");
    try {
     // await setPersistence(auth, browserSessionPersistence);
      await signInWithRedirect(auth, googleProvider);
      //await signInWithPopup(auth, googleProvider);
    } catch (error) {
      console.error("Google Login Error:", error);
    }
  };

  const checkGoogleRedirectResult = async () => {
    console.log("Checking Google Redirect Result");
    try {
      const result = await getRedirectResult(auth);
      console.log("Result:", result);
      if (!result) {
        console.log("Checking currentUser instead...");
        console.log("auth.currentUser:", auth.currentUser);
      }

      if (result) {
        console.log("Google Sign-In Successful:", result);
        const uid = result.user.uid;
        console.log("User UID:", uid);
       // getBackendIDFromFirebaseUID(uid);
      }
    } catch (error) {
      console.error("Error fetching redirect result:", error);
    }
  };

  useEffect(() => {
    checkGoogleRedirectResult();
  }, []);  

  // Facebook Login
  const handleFacebookLogin = async () => {
    try {
      //const result = await signInWithPopup(auth, facebookProvider);
      const result = await signInWithRedirect(auth, facebookProvider);
      const uid = result.user.uid;
      getBackendIDFromFirebaseUID(uid);
    } catch (error) {
      console.error("Facebook Login Error:", error);
    }
  };

  // Email/Password Login
  const handleEmailLogin = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const uid = userCredential.user.uid;
      getBackendIDFromFirebaseUID(uid);
    } catch (error) {
      console.error("Email Login Error:", error);
    }
  };

  // Email/Password Signup
  const handleEmailSignup = async () => {
    try {
      if(email==="" || password===""){
        alert("Please enter both email and password");
        return;
      }
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const uid = userCredential.user.uid;
      getBackendIDFromFirebaseUID(uid);
    } catch (error) {
      console.error("Signup Error:", error);
    }
  };
  useEffect(() => {
    const recaptchaVerifier = new RecaptchaVerifier(auth,
      'recaptcha-container', 
      {
        'size': 'invisible',
      });
      setRecaptchaVerifier(recaptchaVerifier);
      return () => {
        recaptchaVerifier.clear();
      }
  }, [auth]);

  const setUpRecaptcha = () => {
    //auth= getAuth();
    console.log(auth);
    console.log(window.recaptchaVerifier);
    /*
    if (window.recaptchaVerifier) {
      console.log("Destroying old RecaptchaVerifier instance.");
      window.recaptchaVerifier.clear();
      window.recaptchaVerifier = null;
    }*/
    if (!window.recaptchaVerifier) {
      console.log("Setting up recaptcha...");
      console.log("Checking for #recaptcha-container:", document.getElementById("recaptcha-container"));
      try{
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          //callback: (response) => {
           // console.log("reCAPTCHA verified", response);
          //},
        }
      );
    } catch (error) {
      console.error("Error creating RecaptchaVerifier:", error);
    }
      console.log("window.recaptchaVerifier");
    }

    //window.recaptchaVerifier.render().then(widgetId => {
   //   grecaptcha.execute(widgetId, { sitekey: '6LdnnNwqAAAAAM_nxH5v4FJEG_WJUb5ROmzWBxYa' });
   // });

  };

  const handleSendCode = async () => {
    //await setUpRecaptcha();
    //console.log("captcha before send code req.", window.recaptchaVerifier);
    if(!recaptchaVerifier){
      console.log('RecaptchaVerifier not set up');
      return;
    }
    try {
      const confirmation = await signInWithPhoneNumber(
        auth,
        phoneNumber,
        recaptchaVerifier,
        //window.recaptchaVerifier
      );
      setConfirmationResult(confirmation);
      alert('Code sent to your phone');
    } catch (error) {
      console.error('Error during signInWithPhoneNumber', error);
      //window.recaptchaVerifier.render().then(function(widgetId) {
      //  grecaptcha.reset(widgetId);
      //});
    }
  };

  const handleVerifyCode = async () => {
    if (!confirmationResult) return;
    try {
      await confirmationResult.confirm(verificationCode);
      alert('Phone number verified!');
    } catch (error) {
      console.error('Error during code verification', error);
    }
  };


  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
    <div
      style={{
        display: "flex", // Use Flexbox for horizontal stacking
        flexDirection: "row", // Stack children horizontally (default)
        justifyContent: "space-between", // Space between children
        alignItems: "center",
        gap: "10px", // Space between children
        padding: "10px", // Padding around the container
        backgroundColor: "#f4f4f4", // Background color
      }}
    > <h2>Login to View Your Skills</h2>
    <button onClick={toggleSidebar}>মেনু</button>
    </div>

    {/*      
      <button onClick={handleGoogleLogin}>Login with Google</button>

      <button onClick={handleFacebookLogin}>Login with Facebook</button>
    */}
      <h3>Email/Password Login</h3>
      <input type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
      <input type="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
      <button onClick={handleEmailLogin}>Login</button>
      <button onClick={handleEmailSignup}>Signup</button>

      <h3>Phone Authentication</h3>
      <div id="recaptcha-container"></div>
      {!confirmationResult ? (
        <div>
          <input
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="Enter phone number"
          />
          <button onClick={handleSendCode}>Send Verification Code</button>
        </div>
      ) : (
        <div>
          <input
            type="text"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            placeholder="Enter verification code"
          />
          <button onClick={handleVerifyCode}>Verify Code</button>
        </div>
      )}

      {isSidebarVisible && <SidebarNav />}
    </div>
  );
};

export default SocialLogin;